import React from "react";
import { Builder } from "@builder.io/react";

import ResourcesSlider from "@components/Sliders/ResourcesSlider/ResourcesSlider";
import { useResourcesSlider } from "@hooks/useResourcesSlider";

type ResourceSliderWrapperType = {
  resources: any[];
};

const ResourceSliderWrapper: React.FC<ResourceSliderWrapperType> = props => {
  const resourcesList = useResourcesSlider(props?.resources);

  return <ResourcesSlider resourceList={resourcesList} />;
};

export default ResourceSliderWrapper;

export const RegisterResourceSliderWrapper = () => {
  Builder.registerComponent(ResourceSliderWrapper, {
    name: "resource-slider",
    inputs: [
      {
        name: "resources",
        type: "list",
        subFields: [
          {
            name: "resource",
            type: "reference",
            model: "page-resource-post",
          },
        ],
        defaultValue: [],
      },
    ],
  });
};
